import React from "react";
import { connect } from "react-redux";
import Container2 from "../helpers/Container2";

class DescriptionFooter extends React.Component {
  render() {
    return (
      <footer
        className={`description__footer ${
          this.props.darkMode ? "dark--3" : ""
        }`}
      >
        <Container2>
          <div className="description__footer--wrapper">
            <div className="description__footer--col1">
              <h2
                className={`header__medium description__footer--title ${
                  this.props.darkMode ? "white" : ""
                }`}
              >
                {this.props.selectedJob.title}
              </h2>
              <h3 className="description__footer--companyname">
                So Digital Inc.
              </h3>
            </div>
            <div className="description__footer--col2">
              <a
                className="btn btn--footer"
                href={this.props.selectedJob.how_to_apply}
              >
                Apply Now
              </a>
            </div>
          </div>
        </Container2>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedJob: state.selectedJob,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(DescriptionFooter);
